export const NO_CLASSID_ERROR = new Error("Class not found");
export const NO_PASSWORD_ERROR = new Error("Missing password");